// stripeConfig.js

// Mode: live

import { loadStripe } from '@stripe/stripe-js';

const STRIPE_PUBLISHABLE_KEY = "pk_live_51SNyPS2fYNRuAHzmvYKEdhWprXOlRjXyfmvzy92W0iWGaAMdhBflqtUr4BChKjYvSaHddbe4SRujG3B8gEYVlke8008Rh5J7s2";  /* This gets changed during app generations. No need to change, it comes from the Stripe Config*/ 

export const stripePromise = loadStripe(STRIPE_PUBLISHABLE_KEY);

export const paymentProcessor = "stripe";  //stripe|dodopayments|paddle

export const applicationName = "Payexly";

export const paddleClientSideToken = "";

export const paddleEnvironmentMode = "";

export const PLANS = {
  "trialPeriodDurationInDays": 7,
  "order": [
    "lite",
    "standard",
    "advanced",
    "enterprise"
  ],
  "annualSavingPercentage": 18,
  "monthly": {
    "lite": {
      "price": 9.95
    },
    "standard": {
      "price": 19.95
    },
    "advanced": {
      "price": 49.95
    },
    "enterprise": {
      "price": 99.95
    }
  },
  "yearly": {
    "lite": {
      "price": 8.16
    },
    "standard": {
      "price": 16.36
    },
    "advanced": {
      "price": 40.96
    },
    "enterprise": {
      "price": 81.96
    }
  },
  "planAdditionaInfo": {
    "lite": {
      "title": "Lite",
      "description": "Ideal for small teams managing tasks, schedules, and basic operations effortlessly.",
      "maxUserAccounts": 1,
      "features": [
        "Full Access",
        "Metrics & Insights",
        "Customer Support"
      ]
    },
    "standard": {
      "title": "Standard",
      "description": "Optimal for growing organizations handling multiple projects, staff, and data.",
      "popular": true,
      "maxUserAccounts": 10,
      "features": [
        "Full Access",
        "Metrics & Insights",
        "Customer Support"
      ]
    },
    "advanced": {
      "title": "Advanced",
      "description": "Designed for enterprises with advanced reporting, automation, and resource planning.",
      "maxUserAccounts": 25,
      "features": [
        "Full Access",
        "Metrics & Insights",
        "Customer Support"
      ]
    },
    "enterprise": {
      "title": "Enterprise",
      "description": "Tailored for large organizations needing comprehensive control over all operations and teams.",
      "maxUserAccounts": 50,
      "features": [
        "Full Access",
        "Metrics & Insights",
        "Customer Support"
      ]
    }
  }
};